import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import LoyaltyLockIcon from '~/icons/components/LoyaltyLockIcon/LoyaltyLockIcon';
import { mobile, Button } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import PlatinumCountdown from '../PlatinumCountdown/PlatinumCountdown';

const PlatinumLockedCTAWrapper = styled.div`
  ${mobile`
    margin-top: 20px;
    padding: 0 18px;
  `}
`;

const PlatinumCountdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 10px;
`;

const PlatinumLockedButton = styled(Button).attrs({
  variant: 'primaryAddToBag',
  size: 'lg',
})`
  width: 100%;
`;

const labelStyle = css`
  font-size: 18px;
  font-weight: 800;
  letter-spacing: ${-0.4 / 18}em;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textLight};
`;

const StyledLoyaltyLockIcon = styled(LoyaltyLockIcon)`
  position: relative;
  margin-left: -5px;
`;

export default function PlatinumLockedCTA({ tier }) {
  return (
    <PlatinumLockedCTAWrapper>
      {tier && (
        <PlatinumCountdownWrapper>
          <FormattedMessage
            id="site_pdp.platinum_countdown"
            defaultMessage="Unlock this product in"
          />
          <PlatinumCountdown dataAutotag="pdp-main-product-platinum-countdown" />
        </PlatinumCountdownWrapper>
      )}
      <PlatinumLockedButton
        labelStyle={labelStyle}
        data-autotag="pdp-cta-loyalty-platinum-locked-button"
        disabled
      >
        <StyledLoyaltyLockIcon width={25} height={25} color="white" />
        <FormattedMessage
          id="site_pdp.platinum_exclusive_button"
          defaultMessage="Platinum + Exclusive"
        />
      </PlatinumLockedButton>
    </PlatinumLockedCTAWrapper>
  );
}

PlatinumLockedCTA.propTypes = {
  tier: PropTypes.object,
};
